/**
 * @generated SignedSource<<ce11712642cb24880e83154c229c8ebc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VerifyAdminInvitationInput = {
  adminInviteToken: string;
};
export type AdminJoinCommunityButtonMutation$variables = {
  input: VerifyAdminInvitationInput;
};
export type AdminJoinCommunityButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly firstName: string | null;
      readonly id: string;
    } | null;
  };
};
export type AdminJoinCommunityButtonMutation = {
  response: AdminJoinCommunityButtonMutation$data;
  variables: AdminJoinCommunityButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyAdminInvitationResponse",
    "kind": "LinkedField",
    "name": "verifyAdminInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminJoinCommunityButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminJoinCommunityButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "440b263688eae4bdb9f6af4888fbc945",
    "id": null,
    "metadata": {},
    "name": "AdminJoinCommunityButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminJoinCommunityButtonMutation(\n  $input: VerifyAdminInvitationInput!\n) {\n  response: verifyAdminInvitation(input: $input) {\n    node {\n      id\n      firstName\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "093b10d372fd97bbdf317b82df2978a7";

export default node;
